<div ng-controller="registerLevelController as regLevelCtrl" ng-class="{'modal-view': regLevelCtrl.isModal()}">
    <c-auto-form config="regLevelCtrl.autoFormConfig"></c-auto-form>
</div>